import axios from "axios";
import utils from "./utils";

export default {
  send: async ({ coating, quantity, email }) => {
    try {
      const response = await axios.post(`/coating-calculator/send`, {
        ...utils.getCsrfToken(),
        coating,
        quantity,
        email,
      });
      if (response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw new Error("Unable to send mail, please try again later");
    }
  },
};
